import { render } from "./LockListDialog.vue?vue&type=template&id=6d326844"
import script from "./LockListDialog.vue?vue&type=script&lang=js"
export * from "./LockListDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__